import '../../../css/info_components/info_title.css'

function FoodInfoTitle() {
    return (
        <main>
            <div className='info_all_parent'>
                <font className='page_nav_font_active'>
                    Serving Information
                </font>
            </div>
        </main>
    );
}

export default FoodInfoTitle;